<template>
  <v-btn
    icon
    @click="logout"
  >
    <v-icon>mdi-logout</v-icon>
  </v-btn>
</template>

<script>
import apiUtil from '../utils/ApiUtil';

export default {
  methods: {
    async logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
      await apiUtil.logout();
    },
  },
};
</script>
